<template lang="pug">
b-modal(:visible="showModal" @change="$emit('update:showModal', $event)" :title="isAcknowledgment ? 'Edit Acknowledgment' : 'Edit Subscription Package'" size="lg" no-close-on-backdrop)
    form(@submit.prevent="handleSubmit")
        div(class="form-row")
            div(class="form-group col-md-6")
                label {{ isAcknowledgment ? 'Acknowledgment Name' : 'Package Name' }}
                b-form-input(v-model="form.name" :placeholder="isAcknowledgment ? 'e.g., Completion Certificate' : 'e.g., Premium Care Package'" required)
            div(class="form-group col-md-6" v-if="!isAcknowledgment")
                label Price ($)
                b-form-input(type="number" v-model="form.price" min="0" :required="!isAcknowledgment")
            div(class="form-group col-md-6" v-if="!isAcknowledgment")
                label GST (%) 
                b-form-input(type="number" v-model="form.gst" min="0" max="100" step="0.01" placeholder="e.g., 10" required)
        div(class="form-group")
            label Description
            VueEditor(v-model="form.description" :editorToolbar="customToolbar" placeholder="Enter Body" required)
            //- b-form-textarea(v-model="form.description" :placeholder="isAcknowledgment ? 'Describe the acknowledgment purpose and criteria' : 'Describe the package benefits and services'" required)
        div(class="form-row")
            div(class="form-group col-md-6")
                label Start Date
                b-form-input(type="date" v-model="form.startDate" required)
            div(class="form-group col-md-6")
                label End Date
                b-form-input(type="date" v-model="form.endDate" required)
        div(class="form-group")
            b-form-checkbox(v-model="form.active" switch) Recurring Package
        b-form-group(label="Only Clients" class="mt-3")
            b-form-checkbox(v-model="form.isClients" switch)
        b-form-group(label v-if="!form.isClients") 
            label Assign to Groups
            v-select( id="event-group"  :options="groups" :reduce="item => ({ id: item.id, name: item.name })" multiple label="name" placeholder="Select Group" :class="{'invalid': form.groups && form.groups.length === 0}" v-model="form.groups")
        
        b-form-group(label="Clients" v-if="form.isClients")
             v-select(
                class="w-100"
                v-model="form.selectedClients"
                :options="clients"
                :multiple="true"
                label="name"
                track-by="id"
                :reduce="option => option"
                placeholder="Select Clients"
                )
                    template(#option="option")
                        div {{ option.name }}
                    template(#selected-option="option")
                        div {{ option.name }}
        div(class="form-group" v-if="error")
            b-alert(type="danger" dismissible) {{ error }}
    template(v-slot:modal-footer)
        b-button(@click="closeModal" variant="secondary") Cancel
        b-button(type="submit" variant="dark" :disabled="loading" @click="handleSubmit")
            | {{ loading ? 'Saving...' : 'Save Changes' }}
</template>

<script>
import { BModal, BFormInput, BFormTextarea, BFormCheckbox, BButton, BAlert, BFormGroup } from 'bootstrap-vue';
import axios from 'axios';
import { VueEditor } from "vue2-editor";

export default {
    components: {
        BModal,
        VueEditor,
        BFormInput,
        BFormTextarea,
        BFormCheckbox,
        BButton,
        BAlert,
        BFormGroup
    },
    props: {
        showModal: {
            type: Boolean,
            required: true
        },
        subscription: {
            type: Object,
            required: false,
            default: null
        },
        isAcknowledgment: {
            type: Boolean,
            default: false
        },
        groups: {
            type: Array,
            default: () => []
        },
        clients: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            customToolbar: [
                ["bold", "italic", "underline"],
                [{ list: "ordered" }, { list: "bullet" }],
                [
                    { align: "" },
                    { align: "center" },
                    { align: "right" },
                    { align: "justify" },
                ],
                ["link"],
                ["clean"],
            ],
            form: {
                name: '',
                price: '',
                description: '',
                startDate: '',
                endDate: '',
                active: false,
                groups: [],
                isClients: false,
                selectedClients: [],
                gst: 9
            },
            loading: false,
            error: ''
        }
    },
    watch: {
        subscription: {
            handler(newVal) {
                this.mapSubscriptionData(newVal);
            },
            immediate: true,
            deep: true
        },
        groups: {
            handler() {
                
                if (this.subscription) {
                    this.mapSubscriptionData(this.subscription);
                }
            },
            immediate: true
        }
    },
    methods: {
        mapSubscriptionData(subscription) {
            if (!subscription) return;
            
            console.log('Subscription data:', subscription);
            let mappedGroups = [];
            let jsonGroups = JSON.parse(subscription?.crb5c_groups || '[]');
            if (jsonGroups && Array.isArray(jsonGroups)) {
                mappedGroups = jsonGroups.map(groupId => {
                    const group = this.groups.find(g => g.id === groupId);
                    return group ? { id: group.id, name: group.name } : { id: groupId, name: `Group ${groupId}` };
                });
            }
            
            
            let mappedClients = [];
            let jsonClients = JSON.parse(subscription?.crb5c_clients || '[]');
            console.log('Subscription clients:', subscription?.crb5c_clients);
            console.log('Parsed clients:', jsonClients);
            
            if (jsonClients && Array.isArray(jsonClients) && this.clients.length > 0) {
                mappedClients = jsonClients.map(clientId => {
                    const client = this.clients.find(c => c.id === clientId);
                    return client ? { id: client.id, name: client.name } : { id: clientId, name: `Client ${clientId}` };
                }).filter(client => client); 
            }

            this.form = {
                name: subscription.crb5c_title || '',
                price: subscription.crb5c_amount || '',
                description: subscription.crb5c_description || '',
                startDate: subscription.crb5c_datefrom ? subscription.crb5c_datefrom.slice(0,10) : '',
                endDate: subscription.crb5c_datetill ? subscription.crb5c_datetill.slice(0,10) : '',
                active: subscription.crb5c_recurring || false,
                groups: mappedGroups,
                isClients: subscription.crb5c_targetedrecipent || false,
                selectedClients: mappedClients,
                gst: subscription.crb5c_gst || 9
            };
        },

        async handleSubmit() {
            if (!this.form.isClients && this.form.groups.length === 0 && this.form.selectedClients.length === 0) {
                this.error = 'Please select either groups or clients';
                return;
            }
            this.loading = true;
            this.error = '';
            try {
                const payload = {
                    crb5c_title: this.form.name,
                    crb5c_description: this.form.description,
                    crb5c_subscriptionname: this.form.name,
                    crb5c_amount: this.isAcknowledgment ? 0 : Number(this.form.price),
                    crb5c_datefrom: this.form.startDate,
                    crb5c_datetill: this.form.endDate,
                    crb5c_recurring: this.form.active ? true : false,
                    crb5c_groups: this.form.groups.map(group => group.id),
                    crb5c_clients: this.form.selectedClients.map(client => client.id),
                    crb5c_isClients: this.form.isClients,
                    crb5c_gst: this.isAcknowledgment ? 0 : Number(this.form.gst)
                };
                await axios.put(`/api/subscription/${this.subscription.crb5c_subscriptionsid}`, payload);
                this.$emit('edit', { ...this.form });
                this.closeModal();
            } catch (err) {
                this.error = err?.response?.data?.message || 'Failed to update subscription';
            } finally {
                this.loading = false;
            }
        },
        closeModal() {
            this.$emit('update:showModal', false);
        }
    }
}
</script>
